import React, { useEffect } from 'react';
import Carousel from '../Carousel/Carousel';
import UltimasNoticias from '../UltimasNoticias/UltimasNoticias';
import './inicio.css';
import { titular } from '../../json/titular';
import { Link } from 'react-router-dom';
import { carouselInicio } from '../../json/carousel';

const Inicio = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <Carousel bannerData={carouselInicio} search={true} name="banner-principal" />
      <div className='container'>
        <div className='row'>
          <div className='col-12'>
            <div className='secretaria_logo' >
              <div className='secretaria_logo_img' style={{ backgroundImage: `url("https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Normatividad/Ligas/EscudoPIBEH.svg")` }}>

              </div>
            </div>
          </div>
          <div className='secretaria_name'>
            <h1>POLICÍA INDUSTRIAL BANCARIA DEL ESTADO DE HIDALGO</h1>
          </div>
          <div className='secretaria_funciones'>
            <h3 className='title'>FUNCIONES</h3>
            <hr className='hr-gob'/>
            <p>Salvaguardar la integridad y bienes de las personas físicas y morales, públicas y privadas.</p>

            <h3 className='title'>MISIÓN</h3>
            <hr className='hr-gob'/>
            <p>Consolidar la aceptación de nuestros servicios de seguridad intramuros en las modalidades de protección, custodia, vigilancia y traslado para salvaguardar la integridad y los bienes de las personas físicas y morales, públicas y privadas. coadyuvando así con el orden público y el desarrollo económico del Estado de Hidalgo. Garantizando un servicio profesional con personal honesto, respetuoso, responsable, leal, disciplinado y orgulloso de la institución que representa.</p>
            
            <h3 className='title'>VISIÓN</h3>
            <hr className='hr-gob'/>
            <p>Ser reconocidos por los usuarios como el mejor organismo de seguridad intramuros en el Estado de Hidalgo, siempre preocupada por dar un servicio de calidad en beneficio de la ciudadanía hidalguense. Ofreciendo la prestación de servicios óptimos, generando la confianza y aceptación mediante el trabajo comprometido de todos los que integramos a nuestra organización, con el firme propósito de servir con elementos de excelencia, eficacia y eficiencia.</p>
            
            <h3 className='title'>VALORES</h3>
            <hr className='hr-gob'/>
            <p> - Responsabilidad   - Fortaleza   - Compromiso   - Cooperación    -Entorno cultural y ecológico   - Vocación de servicio  -Honor</p>
            <p>- Igualdad y no discriminación    - Interés público  - Liderazgo    -Prudencia    - Respeto   - Respeto de los Derechos Humanos  -Equidad de género </p>
                      
              
              
              <div className='btn_organigrama'>
                <Link to="/Transparencia/Rubros/DetalleRubro/Estructura">Organigrama</Link>
                <Link to="/Transparencia/Rubros/DetalleRubro/Normatividad">Normatividad</Link>
              </div>
              <div className='secretaria-redes'>
                <a href='https://www.facebook.com/PIBEHgo/?locale=es_LA'><i class="fa-brands fa-facebook-f"></i></a>
              </div>
          </div>
        </div>
        <UltimasNoticias/>
        <div className='row'>
          <div className='col-12'>
            <div className='notes_title'>
              <h3 className='title'>TITULAR DE LA POLICÍA INDUSTRIAL BANCARIA DEL ESTADO DE HIDALGO</h3>
              <hr className='hr-gob'/>
            </div>
            <div className='section_notes'>
              {
                titular.map((item, index) =>(
                    <>
                      <div key={ index } className='sec_photo'>
                        <div className='img_secretario' style={{ backgroundImage: `url("${ item.imagen }")` }}>
                        </div>
                      </div>
                      <div className='sec_container'>
                        <div className='sec_name'>
                          <h3>{ item.nombre }</h3>
                        </div>
                        <div className='sec_function'>
                          <h4>Función del Director General</h4>
                          <p>{ item.funcion }</p>
                        </div>
                      </div>
                    </>
                ))
              }
            </div>
          </div>
        </div>
        <div className='row'>
          <div className='col-12'>
            <div className='section_map'>
              <div className='map_name'>
                <h3 className='title'>UBICACIÓN</h3>
                <hr className='hr-gob'/>
              </div>
              <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3746.4486605683487!2d-98.75495698508246!3d20.11532148650024!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x85d10a00c4e02d9d%3A0xc54244dda1ce50aa!2sPolicia+Industrial+Bancaria+del+Estado+de+Hidalgo!5e0!3m2!1ses-419!2smx!4v1548879243476?width=100%25&amp;height=600&amp;hl=es&amp;q=palacio%20de%20gobierno%20pachuca%20hidalgo+(Mi%20nombre%20de%20egocios)&amp;t=&amp;z=14&amp;ie=UTF8&amp;iwloc=B&amp;output=embed"
                      width="100%" 
                      height="300" 
                      frameborder="0" 
                      style={{border:0, marginBottom:50}} 
                      allowfullscreen>
              </iframe>
            </div>
          </div>
        </div>   
      </div>
    </>
  )
}

export default Inicio